<template>
  <div>
    <div class="box box-page">
      <div class="box-body restore-page">
        <div class="box-group-icon">
          <div class="box-icon-left" v-if="page.initial">
            <font-awesome-icon :icon="['fas', 'home']" />
          </div>

          <div class="box-icon-left box-turbo-left" v-if="page.is_turbo">
            <i class="svg-icon svgi-rocket" />
          </div>
          <div class="box-blog-left" v-if="page.is_blog">
            {{ $t("ct-blog") }}
          </div>
          <div class="box-is_member-left" v-if="page.is_member">
            {{ $t("ct-page-is-member") }}
          </div>

          <template
            v-if="page.restrict_areas && page.restrict_areas.length > 0"
          >
            <div
              class="box-icon-left-sm"
              v-for="(restrict, index) in page.restrict_areas"
              :key="index"
              :style="{ 'background-color': restrict.color }"
              v-tooltip="{ content: restrict.name, class: 'tooltip-custom' }"
            ></div>
          </template>
        </div>
        <div
          class="box-image-container"
          :style="`background-image: url('${
            page.configuration && page.configuration.og_image
              ? page.configuration.og_image
              : '/static/images/cheetah-og.png'
          }');`"
        > </div>
      </div>
      <div class="box-footer restore-page">
        <div class="box-info">
          <span class="title title-principal">{{
              page.name.length > 15
                ? page.name.substring(0, 15) + "..."
                : page.name
            }}</span>
          <span v-if="page.title" class="title sub-title">{{
              page.url.length > 40 ? page.url.substring(0, 40) + "..." : page.url
            }}</span>
          <div class="ba-w-100 ba-flex ba-jc-fe">
            <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click="confirmRestore(page)">
              <builderall-icon code='594b'></builderall-icon>
            </button>
            <!-- <a
              class="btn btn-dark btn-editor text-white mt-2"
              target="_blank"
              @click="confirmRestore(page)"
            ><builderall-icon code='594b'></builderall-icon>
            </a> -->
          </div>
        </div>
      </div>
    </div>

    <modal-confirm-component
      :show="modalConfig.show"
      :text="modalConfig.text"
      :type="modalConfig.type"
      @cancel="cancelRestore"
      @confirm="restore"
    ></modal-confirm-component>
  </div>
</template>

<script>
import { restoreDeleted } from "../../../../js/services/editor/page";
import ModalConfirmComponent from "./../../components/ModalConfirm";

export default {
  props: ["page", "website"],
  components: { ModalConfirmComponent },
  data() {
    return {
      modalConfig: {
        type: "",
        text: "",
        show: false,
        page: "",
      },
    };
  },

  methods: {
    restore() {
      restoreDeleted(this.modalConfig.page.encrypted_id).then((res) => {
        this.$snotify.success(this.$t('ct-page-restored-success'));
        this.$emit("restored");
      });
    },
    confirmRestore(page) {
      this.modalConfig.type = this.$t(`ct-restore-page`);
      this.modalConfig.text = this.$t(`ct-confirm-restore-page`);
      this.modalConfig.show = true;
      this.modalConfig.page = page;
    },
    cancelRestore() {
      this.modalConfig.show = false;
      this.modalConfig.page = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.box:not(.new-page) {
  max-width: 360px;
  .box-info {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}

.box-group-icon {
  position: absolute;
  top: 9px;
  left: 10px;
  display: inline-flex;
  align-items: center;
}

.box-icon-left-sm {
  width: 25px;
  height: 25px;
  background-color: #000000;
}

.box-icon-left {
  width: 35px;
  height: 35px;
  background-color: #0080fc;
}

.box-turbo-left {
  width: 35px;
  height: 35px;
  background: #6563ff;
}

.box-blog-left {
  width: auto;
  background-color: #ff9800;
  color: #fff;
  display: inline-block;
  padding: 2px 8px;
  font-size: 17px;
  border-radius: 5px;
}

.box-is_member-left {
  width: auto;
  background-color: #644588;
  color: #fff;
  display: inline-block;
  padding: 2px 8px;
  font-size: 17px;
  border-radius: 5px;
}

.box-icon-left,
.box-icon-left-sm {
  display: inline-flex;
  font-size: 19px;
  color: #fff;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  margin-right: 10px;

  .svg-inline--fa {
    vertical-align: 0;
  }
}

.dropdown-menu {
  box-shadow: 0px 0px 5px #26242459;
}

.box-body.restore-page .box-image-container {
  // filter: grayscale(100%);
}

.box-footer {
  min-height: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SiteCardRestorePage.vue